<app-loading *ngIf="loading()" />

@if (!loading() && group()) {
  <div class="builder-page">
    <!-- Top bar -->
    <div class="builder-topbar" [class.builder-topbar--library-open]="isLibraryOpen()">
      <div class="builder-topbar__left">
        <button class="builder-topbar__back" (click)="goBack()" title="Voltar">
          <i class="pi pi-arrow-left"></i>
        </button>
        <div class="builder-topbar__info">
          <div class="builder-topbar__name-row">
            @if (isEditingName()) {
              <input
                class="builder-topbar__name-input"
                type="text"
                [value]="editingNameValue()"
                (input)="editingNameValue.set($any($event.target).value)"
                (keydown.enter)="confirmNameEdit()"
                (keydown.escape)="cancelNameEdit()"
                (blur)="confirmNameEdit()"
                maxlength="100"
                autocomplete="off" />
            } @else {
              <span class="builder-topbar__name" [title]="group()!.name">{{ group()!.name }}</span>
              <button
                class="builder-topbar__edit-btn"
                title="Editar nome do grupo"
                (click)="startEditingName()">
                <i class="pi pi-pencil"></i>
              </button>
            }
          </div>
          <span
            class="builder-topbar__sub"
            [title]="
              totalMemberCount() +
              (totalMemberCount() === 1 ? ' empresa' : ' empresas') +
              ' · arraste um card sobre outro para reorganizar'
            ">
            {{ totalMemberCount() }}
            {{ totalMemberCount() === 1 ? 'empresa' : 'empresas' }} · arraste um card sobre outro
            para reorganizar
          </span>
        </div>
      </div>

      <div class="builder-topbar__right">
        @if (orgChartImport.canImport()) {
          <app-button
            label="Importar organograma"
            icon="pi pi-upload"
            size="small"
            (sendButtonClick)="openOrgChartImport()" />
        }
        <app-button
          [label]="isLibraryOpen() ? 'Ocultar biblioteca' : 'Adicionar empresa'"
          theme="dashed"
          icon="pi pi-building"
          size="small"
          (sendButtonClick)="toggleLibrary()" />
        <app-button
          *appHasRole="'TENANT'"
          label="Criar empresa"
          theme="dashed"
          icon="pi pi-plus"
          size="small"
          (sendButtonClick)="openQuickCreate()" />
      </div>
    </div>

    <div class="builder-workspace" cdkDropListGroup>
      <!-- Canvas -->
      <div
        class="builder-canvas"
        [class.builder-canvas--panning]="isPanning()"
        (mousedown)="startPan($event)"
        (mousemove)="doPan($event)"
        (mouseup)="endPan()"
        (mouseleave)="endPan()"
        (wheel)="onWheel($event)">
        <div class="builder-canvas__content" [style.transform]="canvasTransform()">
          <div class="orgchart">
            <!-- Root node: group name or primary company card -->
            <div class="orgchart__root-node">
              @if (group()!.primaryMember) {
                <div
                  class="orgchart__root-card orgchart__root-card--has-primary"
                  data-root-card="true"
                  [class.orgchart__root-card--nest-target]="
                    dragState.nestTargetId() === '__ROOT__'
                  ">
                  <div class="orgchart__primary-card">
                    <div class="orgchart__primary-card__info">
                      <span class="orgchart__primary-card__name">{{
                        group()!.primaryMember!.companyName
                      }}</span>
                      <span class="orgchart__primary-card__cnpj">{{
                        group()!.primaryMember!.companyCnpj
                      }}</span>
                    </div>
                    <button
                      class="orgchart__primary-card__remove"
                      title="Remover empresa principal"
                      (click)="onPrimaryMemberRemoved($event)">
                      <i class="pi pi-times"></i>
                    </button>
                  </div>
                </div>
              } @else {
                <div
                  class="orgchart__root-card orgchart__root-card--clickable"
                  data-root-card="true"
                  [class.orgchart__root-card--nest-target]="dragState.nestTargetId() === '__ROOT__'"
                  (click)="onRootCardClick()">
                  <span class="orgchart__root-name">{{ group()!.name }}</span>
                  <span class="orgchart__root-hint">clique para definir empresa principal</span>
                </div>
              }
            </div>

            <!-- Root connector + members -->
            @if (group()!.rootMembers.length) {
              <div class="orgchart__root-connector"></div>
              <ul
                class="orgchart__level"
                cdkDropList
                id="root-drop-list"
                [cdkDropListConnectedTo]="[]"
                [cdkDropListEnterPredicate]="acceptOnlyGroupMembers"
                [cdkDropListSortingDisabled]="true"
                [cdkDropListData]="group()!.rootMembers"
                (cdkDropListDropped)="onRootDrop($event)">
                @for (member of group()!.rootMembers; track member.id) {
                  <li
                    class="orgchart__item"
                    cdkDrag
                    [cdkDragData]="member"
                    [cdkDragDisabled]="isPendingMember(member.id)"
                    (cdkDragMoved)="onRootDragMoved($event)"
                    (cdkDragEnded)="onRootMemberDragEnded($event)">
                    <ng-template cdkDragPreview>
                      <div class="org-card org-card--drag-preview">
                        <div class="org-card__header">
                          <div class="org-card__initials">
                            {{ member.companyName.slice(0, 2).toUpperCase() }}
                          </div>
                          <div class="org-card__content">
                            @if (member.label) {
                              <span class="org-card__badge">{{ member.label }}</span>
                            }
                            <span class="org-card__name">{{ member.companyName }}</span>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <app-group-tree-node
                      [member]="member"
                      [groupId]="group()!.id"
                      [isTenant]="isTenant()"
                      [connectedDropListIds]="[]"
                      [isPendingMember]="isPendingMember"
                      (memberMoved)="onMemberMoved($event)"
                      (memberRemoved)="onMemberAdded()"
                      (memberDroppedInLibrary)="onMemberDroppedInLibrary($event)" />
                  </li>
                }
              </ul>
            } @else {
              <div class="orgchart__root-connector"></div>
              <div
                class="orgchart__empty"
                cdkDropList
                id="root-drop-list"
                [cdkDropListConnectedTo]="[]"
                [cdkDropListEnterPredicate]="acceptOnlyGroupMembers"
                [cdkDropListSortingDisabled]="true"
                [cdkDropListData]="group()!.rootMembers"
                (cdkDropListDropped)="onRootDrop($event)">
                <i class="pi pi-sitemap"></i>
                <p>Nenhuma empresa adicionada ainda.<br />Arraste empresas da biblioteca.</p>
              </div>
            }
          </div>
        </div>
        <app-org-chart-import-progress-card (retryRequested)="openOrgChartImport()" />
        <div class="builder-canvas__footer">
          <div class="zoom-controls">
            <button class="zoom-btn" (click)="zoomOut()">−</button>
            <span class="zoom-val">{{ zoomPercent() }}%</span>
            <button class="zoom-btn" (click)="zoomIn()">+</button>
            <button class="zoom-btn zoom-btn--fit" (click)="fitView()">Ajustar</button>
          </div>
        </div>
      </div>

      @if (isLibraryOpen()) {
        <aside
          class="company-library"
          data-company-library
          cdkDropList
          id="company-library-drop-list"
          [cdkDropListConnectedTo]="['company-library-drop-list']"
          [cdkDropListSortingDisabled]="true"
          [cdkDropListData]="availableCompanies()"
          (cdkDropListDropped)="onCompanyLibraryDrop($event)">
          <header class="company-library__header">
            <div>
              <h2>Biblioteca de empresas</h2>
              <p>Arraste um item para um card do organograma</p>
            </div>
            <button class="company-library__close" title="Fechar painel" (click)="toggleLibrary()">
              <i class="pi pi-times"></i>
            </button>
          </header>

          <div class="company-library__search">
            <div class="company-library__search-field">
              <i class="pi pi-search company-library__search-icon"></i>
              <input
                type="text"
                class="company-library__search-input"
                placeholder="Buscar por nome ou CNPJ"
                aria-label="Buscar empresa na biblioteca"
                [value]="companySearchQuery()"
                (input)="onCompanySearch($event)" />
              @if (isSearchingCompanies()) {
                <button
                  type="button"
                  class="company-library__search-clear"
                  title="Limpar busca"
                  aria-label="Limpar busca"
                  (click)="clearCompanySearch()">
                  <i class="pi pi-times"></i>
                </button>
              }
            </div>
          </div>

          <div class="company-library__summary">
            @if (isSearchingCompanies()) {
              <span>
                {{ filteredCompanies().length }} de {{ availableCompanies().length }} disponíveis
              </span>
            } @else {
              <span>{{ availableCompanies().length }} disponíveis</span>
            }
            <span>arraste →</span>
          </div>

          <div class="company-library__list">
            @if (dragState.isOverLibrary()) {
              <div class="company-library__drop-zone">
                <i class="pi pi-inbox"></i>
                <strong>Solte aqui para devolver à biblioteca</strong>
                <p>
                  Esta empresa e as que estão vinculadas a ela, caso existam, serão removidas do
                  organograma.
                </p>
              </div>
            }

            @if (companiesLoading()) {
              <div class="company-library__state">Carregando empresas...</div>
            } @else if (filteredCompanies().length) {
              @for (company of filteredCompanies(); track company.id) {
                <div
                  class="company-library-card"
                  cdkDrag
                  [cdkDragData]="company"
                  (cdkDragMoved)="onLibraryCompanyDragMoved($event)"
                  (cdkDragEnded)="onLibraryCompanyDragEnded($event)">
                  <ng-template cdkDragPreview>
                    <div class="org-card org-card--drag-preview">
                      <div class="org-card__header">
                        <div class="org-card__initials">
                          {{ company.name.slice(0, 2).toUpperCase() }}
                        </div>
                        <div class="org-card__content">
                          <span class="org-card__name">{{ company.name }}</span>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <button class="company-library-card__handle" title="Arrastar empresa">
                    <i class="pi pi-ellipsis-v"></i>
                    <i class="pi pi-ellipsis-v"></i>
                  </button>
                  <div class="company-library-card__avatar">
                    {{ company.name.slice(0, 2).toUpperCase() }}
                  </div>
                  <div class="company-library-card__content">
                    <strong>{{ company.name }}</strong>
                    <span>
                      @if (company.partners.length) {
                        {{ company.partners.slice(0, 2).join(' · ') }}
                      } @else {
                        {{ company.cnpj }}
                      }
                    </span>
                  </div>
                </div>
              }
            } @else if (isSearchingCompanies()) {
              <div class="company-library__state">
                Nenhuma empresa encontrada.
                <button
                  type="button"
                  class="company-library__state-action"
                  (click)="clearCompanySearch()">
                  Limpar busca
                </button>
              </div>
            } @else {
              <div class="company-library__state">Todas as empresas já estão no organograma.</div>
            }
          </div>
        </aside>
      }
    </div>
  </div>
}

<app-quick-create-company-modal #quickCreateModal (companyCreated)="onMemberAdded()" />
<app-set-primary-member-modal #setPrimaryModal (primaryMemberSet)="onMemberAdded()" />
<app-org-chart-import-upload-modal #orgChartImportModal />
<app-org-chart-import-review-modal />
